import { render } from "./SkySwitch.vue?vue&type=template&id=3f1df4c7&scoped=true"
import script from "./SkySwitch.vue?vue&type=script&lang=js"
export * from "./SkySwitch.vue?vue&type=script&lang=js"

import "./SkySwitch.vue?vue&type=style&index=0&id=3f1df4c7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f1df4c7"]])

export default __exports__